import { Chakra } from "@airhelp/react-ui-components";
import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { RowStyles } from "components/Row";
import { getParentLanguage } from "utils/localeUtils";
import config from "config/config";

const { Flex, Text, useToken } = Chakra;

const CONTACT_URL = `${config.webappUrl}/contact?lang=`;

const CallToAction = () => {
  const language = useLanguage();
  const translations = useTranslations();
  const [primary500] = useToken("colors", ["primary.500"]);

  const translationVariables = {
    "%login-link-attrs%": `href="${CONTACT_URL}${getParentLanguage(
      language
    )}" target="_blank" rel="noopener noreferrer" style="text-decoration: none; color: ${primary500}"`,
  };

  return (
    <Flex
      width="full"
      gridColumn="1 / -1"
      rounded="xl"
      mx="auto"
      p={8}
      direction="column"
      sx={RowStyles["colored-hills"]}
    >
      <Text fontWeight="bold" fontSize="xl" color="white" mb={4}>
        {translations("cant_find")}
      </Text>
      <Text
        fontSize="lg"
        color="white"
        dangerouslySetInnerHTML={{
          __html: translations("if_you_have_a_claim", translationVariables),
        }}
      />
    </Flex>
  );
};

export default CallToAction;
